import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export default function PortalDatenschutz() {
  const q = useQuery({
    queryKey: ["portal-legal", "datenschutz"],
    queryFn: async () => (await api.get("/portal/legal/datenschutz")).data,
  });
  const text = q.data?.value || "";
  return (
    <div className="space-y-4" data-testid="portal-datenschutz">
      <div>
        <div className="text-3xl font-black uppercase tracking-tight">Datenschutz</div>
      </div>
      {q.isLoading && <div className="text-zinc-500">Lade…</div>}
      {!q.isLoading && !text && (
        <div className="border border-dashed border-zinc-800 rounded-sm p-8 text-center text-zinc-500">
          Datenschutzerklärung wird gerade gepflegt.
        </div>
      )}
      {text && (
        <div className="border border-zinc-800 rounded-lg p-6 bg-zinc-900 whitespace-pre-wrap text-sm text-zinc-300 leading-relaxed">
          {text}
        </div>
      )}
    </div>
  );
}
